//libs
import React, { memo, useState } from 'react';

//styles
import { Switch, SliderContainer, SliderButton, Slider } from './styles';

interface ToggleButtonProps {
  values: string[];
  onChange: (data: string) => void;
}

function ToggleButton({ values, onChange }: ToggleButtonProps) {
  const [toggleState, setToggleState] = useState(false);
  const toggleUnits = (data: string) => {
    setToggleState(!toggleState);
    onChange(data);
  };
  return (
    <Switch className="toggle">
      <SliderContainer>
        {values.map((data, i) => {
          return (
            <SliderButton key={i} onClick={() => toggleUnits(data)}>
              {data}
            </SliderButton>
          );
        })}
        <Slider toggle={toggleState} />
      </SliderContainer>
    </Switch>
  );
}

export default memo(ToggleButton);
